import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType, SlotsType } from 'vue'


export const querytableColumnButtongroupProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
})

export type QuerytableColumnButtongroupProps = Partial<ExtractPropTypes<ReturnType<typeof querytableColumnButtongroupProps>>>

export default defineComponent({
  name: 'OQuerytableColumnButtongroup',
  inheritAttrs: false,
  props: querytableColumnButtongroupProps(),
  slots: Object as SlotsType<{
    default: any
  }>,
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
